var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStatystyki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "16841543171586787981 1",
    clipPath: "url(#clip0_71_4086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.41006 15.1901H4.65006H7.13006H8.37006H10.8501H12.0901H14.5701H15.1901V14.5701H14.5701V0.310059H12.0901V14.5701H10.8501V3.41006H8.37006V14.5701H7.13006V6.51006H4.65006V14.5701H3.41006V9.61006H0.930059V14.5701H0.310059V15.1901H0.930059H3.41006ZM12.7101 0.930059H13.9501V14.5701H12.7101V0.930059ZM8.99006 4.03006H10.2301V14.5701H8.99006V4.03006ZM5.27006 7.13006H6.51006V14.5701H5.27006V7.13006ZM1.55006 10.2301H2.79006V14.5701H1.55006V10.2301Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_4086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 15.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatystyki);
export default __webpack_public_path__ + "static/media/statystyki.fc234a10367fb3c6ae1b07fe7e3e4da4.svg";
export { ForwardRef as ReactComponent };